/**
 * Canonical list of the 20 Sherwin-Williams partner section types (#21311).
 *
 * Single source of truth for:
 * - the v1→v2 identity converter registrations (convert-presentation-section-v1-to-v2/converters/)
 * - the v2 page options (get-presentation-page-options.ts exposes the ADDABLE_* subset as pages)
 * - the v2 section registry in react-quote (PresentationNext/sections/partners/index.ts) — that map
 *   needs explicit component imports so it can't be derived, but its keys must cover this list.
 */
export const SHERWIN_WILLIAMS_SECTION_TYPES = [
  'sherwin-williams-popular-colors',
  'sherwin-williams-color-of-the-year',
  'sherwin-williams-top-colors',
  'sherwin-williams-finest-whites-neutrals',
  'sherwin-williams-expert-collections',
  'sherwin-williams-explore-exterior',
  'sherwin-williams-color-samples',
  'sherwin-williams-chips-to-door',
  'sherwin-williams-hottest-colors',
  'sherwin-williams-finest-whites',
  'sherwin-williams-peel-n-stick',
  'sherwin-williams-color-help',
  'sherwin-williams-upload-photo',
  'sherwin-williams-schedule-consultation',
  'sherwin-williams-match-a-photo',
  'sherwin-williams-paint-color-visualizer',
  'sherwin-williams-color-expert',
  'sherwin-williams-sample-colors',
  'sherwin-williams-designer-color-collection',
  'sherwin-williams-colormix-forecast'
] as const

export type SherwinWilliamsSectionType = (typeof SHERWIN_WILLIAMS_SECTION_TYPES)[number]

/**
 * The subset offered in the v2 page-select dialog (the rest are legacy types kept renderable
 * for old docs and v1→v2 conversion, mirroring which types the v1 add-section catalog offers).
 */
export const ADDABLE_SHERWIN_WILLIAMS_PAGES: Array<{ type: SherwinWilliamsSectionType; label: string }> = [
  { type: 'sherwin-williams-popular-colors', label: 'Most Popular Colors' },
  { type: 'sherwin-williams-color-of-the-year', label: 'Color of the Year' },
  { type: 'sherwin-williams-top-colors', label: 'Top Colors' },
  { type: 'sherwin-williams-finest-whites-neutrals', label: 'Brightest Whites & Neutrals' },
  { type: 'sherwin-williams-designer-color-collection', label: 'Designer Color Collection' },
  { type: 'sherwin-williams-colormix-forecast', label: 'Colormix Forecast' },
  { type: 'sherwin-williams-explore-exterior', label: 'Explore Exterior Paint' },
  { type: 'sherwin-williams-schedule-consultation', label: 'Schedule Free Consultation' },
  { type: 'sherwin-williams-paint-color-visualizer', label: 'Paint Color Visualizer' },
  { type: 'sherwin-williams-sample-colors', label: 'Sample Color In Your Space' },
  { type: 'sherwin-williams-color-expert', label: 'Color Expert App' }
]
